import React from 'react';
import AppContext from 'contexts/AppContext';
import { useHistory } from 'react-router-dom';
import PermissionCode from 'types/enums/PermissionCode';
import { hasPermission } from 'utils/hasPermission';
import useSetupInitialState from 'hooks/useSetupInitialState';
import { getVenue } from 'services/venuesServices';
import UserRoleType from 'types/enums/UserRoleType';
import 'styles/pages/SelectPaymentTypePage.scss';

type PaymentItem = {
  name: string;
  icon: string;
  borderColor: string;
  bg: string;
  redirect: string;
  code: string;
};
const payments: PaymentItem[] = [
  {
    code: 'first-data',
    name: 'First Data',
    icon: '/images/fiserv-logo.png',
    borderColor: '#FF6600',
    bg: '#FF6600',
    redirect: '/private/admin/payments/first-data',
  },
  {
    code: 'izipay',
    name: 'Izipay',
    icon: '/images/izipay-logo.png',
    borderColor: '#FF4240',
    bg: '#FF4240',
    redirect: '/private/admin/payments/izipay',
  },
  {
    code: 'mercado-pago',
    name: 'Mercado Pago',
    icon: '/images/mercado-pago-logo.png',
    borderColor: '#FFE700',
    bg: '#FFE700',
    redirect: '/private/admin/payments/mercado-pago',
  },
  {
    code: 'mercado-pago-checkout',
    name: 'Mercado Pago Checkout',
    icon: '/images/mercado-pago-logo.png',
    borderColor: '#FFE700',
    bg: '#FFE700',
    redirect: '/private/admin/payments/mercado-pago-checkout',
  },
  {
    code: 'mercado-pago-point',
    name: 'Mercado Pago Checkout Point',
    icon: '/images/mercado-pago-logo.png',
    borderColor: '#FFE700',
    bg: '#FFE700',
    redirect: '/private/admin/payments/mercado-pago-point',
  },
  {
    code: 'clover-point',
    name: 'Clover Point',
    icon: '/images/clover-logo.png',
    borderColor: '#E6E6E6',
    bg: '#E6E6E610',
    redirect: '/private/admin/payments/clover-point',
  },
  {
    code: 'fiserv-qr',
    name: 'Fiserv QR',
    icon: '/images/white-qr.png',
    borderColor: '#FF6600',
    bg: '#FF6600',
    redirect: '/private/admin/payments/fiserv-qr',
  },
  {
    code: 'sitef',
    name: 'Sitef',
    icon: '/images/sitef-logo.png',
    borderColor: '#FF6600',
    bg: '#FF6600',
    redirect: '/private/admin/payments/sitef',
  },
];

export default (): JSX.Element => {
  const history = useHistory();
  const { authData, permissions } = React.useContext(AppContext);
  const entity = useSetupInitialState();
  const [filteredPayments, setFilteredPayments] = React.useState<PaymentItem[]>([]);
  const isVenueEditor = authData?.user?.role === UserRoleType.VenueEditor;

  React.useEffect(() => {
    const handlePermissions = async () => {
      if (!hasPermission(permissions, PermissionCode.PaymentMethodsView)) {
        history.push('/private/welcome');
      }
    };

    handlePermissions();
  }, [authData?.user.role]);

  React.useEffect(() => {
    if (!entity && !isVenueEditor) {
      setFilteredPayments(payments);
      return;
    }
    const filterPayments = async () => {
      const completeVenue = await getVenue(entity?.id ?? '');
      if (!completeVenue) return;

      const { paymentConfig } = completeVenue;
      if (!paymentConfig) return;

      let newPayments: PaymentItem[] = payments;
      // Solo disponibles para admin.
      const disabledMethodsForVenueEditor = [
        'izipay',
        'sitef',
        'mercado-pago',
        'mercado-pago-checkout',
        'mercado-pago-point',
      ];
      newPayments = newPayments.filter((item) => !disabledMethodsForVenueEditor.includes(item.code));

      if (!paymentConfig.fiservQrConfigId) {
        newPayments = newPayments.filter((item) => item.code !== 'fiserv-qr');
      }

      setFilteredPayments(newPayments);
    };

    filterPayments();
  }, [entity]);

  return (
    <div className="payment-container-grid">
      {filteredPayments.map((payment, i) => {
        return (
          <article
            key={i}
            onClick={() => history.push(payment.redirect)}
            className="card"
            style={{
              borderColor: payment.borderColor,
              backgroundColor: payment.bg,
            }}
          >
            <div className="ctn">
              <img src={payment.icon ?? ''} alt={payment.name} />
              <p>{payment.name}</p>
            </div>
          </article>
        );
      })}
    </div>
  );
};
